import { Controller } from "@hotwired/stimulus"
import * as Turbo from "../../src/shared/vendor/turbo"

export default class extends Controller {
  static targets = [
    "checkbox"
  ]

  static values = {
    todoListId: Number,
    itemId: Number
  }

  updateDatabaseItemStatus () {
    const checkbox = this.checkboxTarget
    const completed = checkbox.checked
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

    Turbo.fetch(`/admin/turbo/todo_lists/${this.todoListIdValue}/items/${this.itemIdValue}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ completed })
    })
      .then(response => {
        if (response.ok) {
          return response.text().then(html => Turbo.renderStreamMessage(html))
        } else {
          console.error("Turbo request failed", response)
        }
      })
  }
}
